import React from "react";
import { connect } from "react-redux";
import Container2 from "../helpers/Container2";

class DescriptionApply extends React.Component {
  render() {
    return (
      <div className="description__apply">
        <Container2>
          <div className="description__apply--wrapper">
            <h2 className="header__medium description__apply--title">
              How To Apply
            </h2>
            <p className="description__apply--par">
              Morbi interdum mollis sapien. Sed ac risus. Phasellus lacinia,
              magna a ullamcorper laoreet, lectus arcu pulvinar risus, vitae
              facilisis libero dolor a purus. Sed vel lacus. Mauris nibh felis,
              adipiscing varius, adipiscing in, lacinia vel, tellus.
            </p>
            <a className="description__apply--link" href="/">
              {this.props.selectedJob.how_to_apply}
            </a>
          </div>
        </Container2>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedJob: state.selectedJob,
  };
};

export default connect(mapStateToProps)(DescriptionApply);
